import axios, { AxiosRequestConfig } from "axios";

import { SCREEN_PATHS } from "@APP/navigation";

import AppLocalStorage from "../AppLocalStorage";

import { HEADERS } from "./constants";

// Optional logout handler
const handleLogout = () => {
  AppLocalStorage.removeItem("auth.token");
  window.location.href = SCREEN_PATHS.LOGIN; // or navigate using your router
};

type RequestOptions = {
  auth?: boolean;
};

const REQUEST_DEFAULT_OPTIONS: RequestOptions = {
  auth: true,
};

// Create an Axios instance
const axiosInstance = axios.create();

// Add interceptor to handle 401 globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleLogout();
    }

    return Promise.reject(error);
  },
);

/**
 * HTTP client wrapper around Axios.
 */
const request = async <T = any>(config: AxiosRequestConfig, options = REQUEST_DEFAULT_OPTIONS) => {
  options = { ...REQUEST_DEFAULT_OPTIONS, ...options };
  let headers = config.headers || {};

  // Attach auth token if needed
  if (options.auth) {
    const bankifiToken = AppLocalStorage.getItem("auth.token");
    if (bankifiToken) {
      headers = { ...headers, [HEADERS.AUTH_HEADER]: bankifiToken };
    }
  }

  return axiosInstance.request<T>({ ...config, headers });
};

export default request;
